import script from "./AddCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomer.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomer.vue?vue&type=style&index=0&id=2361fdb0&lang=css"

const __exports__ = script;

export default __exports__